import React from 'react';
import styled from '@emotion/styled';
import { colors, fontFamilies } from '../baseStyle/Variables';
import LanguageToggle from '../languageToggle/LanguageToggle';
import { useTranslation } from 'react-i18next';

const FooterStyle = styled.div`
  height: 2.25rem;
  width: 100%;
  background: ${colors.white};
  position: absolute;
  left: 0;
  bottom: 0;
`;

const FooterText = styled.div`
  font-family: ${fontFamilies.interSemiBold};
  font-size: 0.75rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.darkGray};
`;

const InsideStyle = styled.div`
  margin-top: auto;
  margin-bottom: auto;
`;

const LanguageToggleWrapper = styled.div<{ isInstallmentLoan: boolean }>`
  ${(props) => (props.isInstallmentLoan ? `margin: 1.5rem 2rem 2.9rem;` : `margin: 1.5rem 2rem 1.9rem;`)}
`;

const Footer: React.FC<{ isInstallmentLoan: boolean; languageTogglerEnabled: boolean; track: (eventName: string, payload?: object) => void }> = ({
  isInstallmentLoan,
  languageTogglerEnabled,
  track,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {languageTogglerEnabled && (
        <LanguageToggleWrapper isInstallmentLoan={isInstallmentLoan}>
          <LanguageToggle track={track} />
        </LanguageToggleWrapper>
      )}
      {isInstallmentLoan && (
        <FooterStyle>
          <FooterText>
            <InsideStyle>{t(($) => $.footer.loanIssueBybank)}</InsideStyle>
          </FooterText>
        </FooterStyle>
      )}
    </>
  );
};

export default Footer;
